import axios from 'axios';
import authHeader from '../auth-header';
// Pakai tag ini kalau mau nge post file
import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

/**
 *
 * FILE INI BERFUNGSI UNTUK MENAMPUNG SEMUA FUNGSI REQUEST API
 * ?page=1&size=5' pakai ini untuk fungsi pagination
 * 
 * 
**/
const getPaktaIntegritas = 'pakta-integritas';
const postPaktaIntegritasUrl = 'pakta-integritas';
const putPaktaIntegritas = 'pakta-integritas/';
const deletePaktaIntegritas = 'pakta-integritas/';

class PaktaIntegritasService {

    postPaktaIntegritas(formData) {
        return axios
        .post(
            API_URL + postPaktaIntegritasUrl,        // url post PaktaIntegritas
            formData,                   // data yang ingin di post
            { headers: authHeader() }   // Bearer Token
        );
    }

    putPaktaIntegritas(formData) {
        var headers = authHeader(); 
        return axios
        .put(
            API_URL + putPaktaIntegritas + formData.idKategoriPaktaIntegritas, formData,
            { headers: authHeader() }
        );
    }

    deletePaktaIntegritas(formData) {
        var headers = authHeader(); 
        return axios
        .delete(
            API_URL + deletePaktaIntegritas + formData.idKategoriPaktaIntegritas,
            { headers: authHeader() }
        );
    }

    getPaktaIntegritas(currentPage, pageSize,filter){
        return axios.get(
            API_URL + getPaktaIntegritas + '?pageNo=' + currentPage + '&pageSize=10' + pageSize + '&filter=' + filter,
            { headers: authHeader() }
        );
    }

}

export default new PaktaIntegritasService();
